import { AUTO_TEXT_SIZE_PRESETS } from '../../../../core/constants.js';
import type { TextSize } from '../../../../core/types/text-size.js';
import { getTextMeasurer } from '../../../../core/utils/text-measure.js';
import {
  HONEYCOMB_LABEL_FONT_SIZE,
  HONEYCOMB_LABEL_FONT_SIZE_OFFSET,
  HONEYCOMB_VALUE_FONT_WEIGHT,
  HONEYCOMB_VALUE_LINE_HEIGHT_RATIO,
} from '../../../constants.js';

export const getFontSizes = (
  ctx: CanvasRenderingContext2D,
  textSize: TextSize,
  valueText: string,
  availableWidth: number,
  availableHeight: number,
): { valueFontSize: number; labelFontSize: number } => {
  if (textSize !== 'auto') {
    return {
      valueFontSize: textSize,
      labelFontSize: Math.max(0, textSize - HONEYCOMB_LABEL_FONT_SIZE_OFFSET),
    };
  }

  const measure = getTextMeasurer(ctx, textSize, {
    fontWeight: HONEYCOMB_VALUE_FONT_WEIGHT,
  });

  for (let i = 0; i < AUTO_TEXT_SIZE_PRESETS.length; i++) {
    const valueFontSize = AUTO_TEXT_SIZE_PRESETS[i];
    const labelFontSize = valueFontSize - HONEYCOMB_LABEL_FONT_SIZE_OFFSET;
    const totalHeight = valueFontSize + valueFontSize * HONEYCOMB_VALUE_LINE_HEIGHT_RATIO + labelFontSize;

    if (
      measure(valueText, valueFontSize) <= availableWidth &&
      totalHeight <= availableHeight
    ) {
      return {
        valueFontSize,
        labelFontSize,
      };
    }
  }

  const smallestPreset = AUTO_TEXT_SIZE_PRESETS.at(-1) ?? HONEYCOMB_LABEL_FONT_SIZE;

  return {
    valueFontSize: smallestPreset + HONEYCOMB_LABEL_FONT_SIZE_OFFSET,
    labelFontSize: smallestPreset,
  };
};
